import { sllrHttp } from 'http.js';

export const getChats = (payload) => {
  return sllrHttp.get(`/omniMessaging/chats`, payload);
};

export const getChatConversation = (chatId, payload) => {
  return sllrHttp.get(`/omniMessaging/chats/${chatId}`, payload);
};

export const sendMessage = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/sendMessage/${platform}`, payload);
};

export const sendImages = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/send-image/${platform}`, payload);
};

export const sendOrderConfirmMessage = (platform, payload) => {
  return sllrHttp.post(
    `/omniMessaging/send-order-confirmed-message/${platform}`,
    payload
  );
};

export const shareProductWithCustomers = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/share-product/${platform}`, payload);
};

export const shareProductWithCustomersV2 = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/share-product-v2/${platform}`, payload);
};

export const getUnReadChats = () => {
  return sllrHttp.get(`/omniMessaging/unread-chats`);
};

export const sendCart = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/send-cart/${platform}`, payload);
};

export const collectShippingInfo = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/collect-shipping/${platform}`, payload);
};

export const updateCart = (id, payload) => {
  return sllrHttp.put(`/omniMessaging/customers/${id}/cart`, payload);
};

export const updateCustomerInfo = (id, payload) => {
  return sllrHttp.put(`/omniMessaging/customers/${id}`, payload);
};

export const sendProductAction = (payload, platform) => {
  return sllrHttp.post(`omniMessaging/bot/trigger/${platform}`, payload);
};

export const markAsUnread = (platform, payload) => {
  return sllrHttp.post(`/omniMessaging/mark-as-unread/${platform}`, payload);
};

export const markAsSean = (payload) => {
  return sllrHttp.put(`/omniMessaging/seen/`, payload);
};

export const updateChatStatus = (chatId, payload) => {
  return sllrHttp.post(`/omniMessaging/update-chat-status/${chatId}`, payload);
};

export const assignChat = (payload, platform) => {
  return sllrHttp.post(`/omniMessaging/assign-chat/${platform}`, payload);
};

export const unAssignChat = (payload, platform) => {
  return sllrHttp.post(`/omniMessaging/unassign-chat/${platform}`, payload);
};

export const getMessageById = ({ chatId, messageId }) => {
  return sllrHttp.get(`/omniMessaging/messages/${chatId}/${messageId}`);
};

export const recentNotifications = ({ timestamp }) => {
  return sllrHttp.get(
    `omniMessaging/recent-notifications?timestamp=${timestamp}`
  );
};

export const createReply = (payload) => {
  return sllrHttp.post(`/omniMessaging/saved-replies`, payload);
};

export const getSavedReplies = () => {
  return sllrHttp.get(`/omniMessaging/saved-replies`);
};

export const deleteSavedReply = (id) => {
  return sllrHttp.delete(`/omniMessaging/saved-replies/${id}`);
};

export const updateSavedReply = (id) => {
  return sllrHttp.put(`/omniMessaging/saved-replies/${id}`);
};

export const activeWelcomeMessage = (payload) => {
  return sllrHttp.put(`/omniMessaging/toggle-bot-message-activation`, payload);
};

export const resendFailedMessage = (payload) => {
  return sllrHttp.post(`/omniMessaging/resend`, payload);
};
